import { contactData } from '@/mocks/home';

export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">{contactData.title}</h2>
          <p className="text-sm text-foreground-600 leading-relaxed mb-10">{contactData.description}</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            <div className="flex items-center gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 shrink-0">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500 mb-0.5">投稿邮箱</div>
                <div className="text-sm font-medium text-foreground-900">{contactData.email}</div>
              </div>
            </div>

            <div className="flex items-center gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 shrink-0">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <div className="text-left">
                <div className="text-xs text-foreground-500 mb-0.5">微信投稿</div>
                <div className="text-sm font-medium text-foreground-900">{contactData.wechat}</div>
              </div>
            </div>
          </div>

          <div className="p-4 rounded-lg bg-accent-100/70 border border-accent-200/50">
            <p className="text-xs text-accent-800 flex items-center justify-center gap-2">
              <i className="ri-shield-check-line"></i>
              {contactData.note}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}